import { HttpHeaders } from "@angular/common/http";
import {PagerOptions} from "../app/app.types";
import {
    BehaviorSubject,
    filter,
    from,
    Observable,
    scan,
    switchMap,
    tap,
    zip,
} from "rxjs";

const convert = (val: string): any => {
    val = decodeURIComponent(val);
    if (
        /^[12]{1}[90]{1}[0-9]{2}\-[0-9]{2}-[0-9]{2}/.test(val) &&
        !isNaN(Date.parse(val))
    )
        return new Date(Date.parse(val));
    if (/^[0-9]{1,20}\.[0-9]{1,20}$/.test(val)) return parseFloat(val);
    if (/^[0-9]{1,20}$/.test(val)) return parseInt(val);

    if (val.indexOf("{") > -1) {
        // if JSON convert to object
        try {
            return JSON.parse(val);
        } catch (e) {}
    }
    if (val === "true") return true;
    if (val === "false") return false;
    return val;
};
const convertToString = (val: any): any => {
    if (val instanceof Date) return val.toISOString().split(".")[0] + "Z"; // Java parsable date string (removes milliseconds)
    // arrays of string | number should be csv
    // if(Array.isArray(val) && typeof val[0] !== 'object') return encodeURIComponent(val.join(','));
    if (typeof val === "object") return encodeURIComponent(JSON.stringify(val));
    return encodeURIComponent(val);
};

export class QueryString {
    /**
     * Convert querystring to object. Converts numbers and decodes strings
     * @param qs Query string
     * @param separator defaults to &, set to ; for parsing ; separated strings
     * @returns Object from Query String
     */
    static parse(
        qs: string | null | undefined,
        separator: "&" | ";" = "&"
    ): any {
        const query = qs?.slice(qs.indexOf("?") + 1);
        return (
            query?.split(separator).reduce((g: any, a: string) => {
                const [prop, value] = a.split("=");
                if (g[prop]) {
                    if (Array.isArray(g[prop])) g[prop].push(convert(value));
                    else g[prop] = [g[prop], convert(value)];
                } else {
                    g[prop] = convert(value);
                }
                return g;
            }, {}) || {}
        );
    }
    /**
     * Converts object to querystring handles date conversion and string encoding
     * @param obj
     * @returns
     */
    static stringify(obj: any): string {
        return Object.keys(obj)
            .map((k) => {
                if (Array.isArray(obj[k])) {
                    return obj[k]
                        .map((val: any) => `${k}=${convertToString(val)}`)
                        .join("&");
                } else {
                    return `${k}=${convertToString(obj[k])}`;
                }
            })
            .join("&");
    }
}

export function seqZip<T>(arrObs: Observable<T>[]): Observable<T[]> {
    const res: T[] = [];
    const next$ = new BehaviorSubject<null>(null);
    let count = 0;
    return zip(from(arrObs), next$).pipe(
        switchMap(([x]): Observable<T> => x),
        tap((res) => {
            count++;
            next$.next(null);
        }),
        scan((acc, val) => [...acc, val], ([] as T[])),
        filter((acc) => arrObs.length === count)
    );
}

export const requestSettings = {
    httpOptions: {
        headers: new HttpHeaders({
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        })
    },
    timeoutPeriod: 30000
};

export const stringifyPagerOptions = (opts: PagerOptions) => {
    const optionsArray: string[] = [];

    if (opts.pageSize != null) {optionsArray.push("pageSize=" + opts.pageSize);}
    if (opts.page != null) {optionsArray.push("page=" + opts.page);}
    if (opts.search != null) {optionsArray.push("search=" + opts.search.map(x => x.type + "=" + x.searchString.toLowerCase()).join(","));}
    if (opts.filter != null) {optionsArray.push("filter=" + opts.filter.type + "=" + opts.filter.filterString);}
    if (opts.orderBy != null) {optionsArray.push("orderBy=" + opts.orderBy);}
    if (opts.ascending != null) {optionsArray.push("ascending=" + opts.ascending);}
    if (opts.usePaging === false) {optionsArray.push("usePaging=false");}

    const optionsString = "?" + optionsArray.join("&");

    return optionsString;
};
